import React from "react";
import { DM_INTENT_CHIPS } from "../../utils/chatIntent";

// DmIntentChips — the DM-tab intent filter row (Design Bible D11, frame 5a).
// PERMANENTLY visible under the search field, DM tab ONLY (the parent never
// mounts it in lane tabs — there the tab is the filter). Chips: All · Player
// Opportunity · Discuss about Player · Networking · Partnership · Manual, counts
// DM-scoped. This is a DIFFERENT control from the 4b search-scope chips ("Search
// in: …"), which belong to search and stay untouched.
//
// CANON-SPECS §A intent-chip tokens: radius 999px, padding 4px 10px, 11px/600.
// Active "All": bg #101828, white, count opacity .7. Inactive: bg #F2F4F7, text
// #475467, count #98A2B3. The row overflow-scrolls with a 36px right fade mask
// (5a) so it never wraps or clips hard.
//
// Props:
//   counts  { all: n, player_opportunity: n, ... } DM-scoped per-intent counts.
//   active  selected intent key ("all" = no filter).
//   onChange(key) => void
//   t       i18n passthrough.
const DmIntentChips = ({ counts = {}, active = "all", onChange, t = (s) => s }) => {
  return (
    <div className="relative">
      <div
        className="flex items-center gap-1.5 overflow-x-auto pr-9"
        style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
      >
        {DM_INTENT_CHIPS.map((chip) => {
          // "All" always shows; the five intents only when they have DM matches
          // (5a renders the populated subset, the rest are a viewport crop —
          // CANON-SPECS AMBIGUITÄT-7). Zero-count intents simply don't clutter.
          const count = counts[chip.key] || 0;
          if (chip.key !== "all" && count === 0) return null;
          const isActive = chip.key === active;
          return (
            <button
              key={chip.key}
              type="button"
              onClick={() => onChange?.(chip.key)}
              aria-pressed={isActive}
              className="flex flex-shrink-0 items-center gap-1 rounded-full font-semibold"
              style={{
                padding: "4px 10px",
                fontSize: "11px",
                background: isActive ? "#101828" : "#F2F4F7",
                color: isActive ? "#FFFFFF" : "#475467",
              }}
            >
              <span>{t(chip.label)}</span>
              <span style={{ color: isActive ? "#FFFFFF" : "#98A2B3", opacity: isActive ? 0.7 : 1 }}>
                {count}
              </span>
            </button>
          );
        })}
      </div>
      {/* 36px right fade mask (5a) — the chips overflow-scroll under it. */}
      <div
        className="pointer-events-none absolute inset-y-0 right-0 w-9"
        style={{ background: "linear-gradient(90deg, rgba(255,255,255,0), #fff)" }}
        aria-hidden="true"
      />
    </div>
  );
};

export default DmIntentChips;
